import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import img from "../assets/journey.jpg";

export default function OurJourney() {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="bg-gray-300 py-16 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">
      {/* ✅ Left Side - Text */}
      <div className="md:w-1/2">
        <h2 className="text-4xl font-extrabold text-gray-800 mb-4">
          A Glimpse into the X7 Group
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          From a small team to big dreams to a trusted name in innovation — 
          our journey has been powered by passion, creativity, and relentless pursuit of excellence.
        </p>
      </div>

      {/* ✅ Right Side - Video Preview */}
      <div
        className="md:w-1/2 relative group cursor-pointer"
        onClick={() => setShowVideo(true)}
      >
        {/* Thumbnail */}
        <img
          src={img}
          alt="Our Journey Video"
          className="w-full rounded-2xl shadow-xl object-cover transition-transform duration-300 group-hover:scale-105"
        />

        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-white/70 p-6 rounded-full shadow-lg transition hover:scale-110">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="orange"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              className="w-10 h-10"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.25 5.25v13.5L19.5 12 5.25 5.25z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* ✅ Video Modal (Popup Player) */}
      <AnimatePresence>
        {showVideo && (
          <motion.div
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="relative w-[90%] md:w-[70%] lg:w-[60%] aspect-video rounded-2xl overflow-hidden shadow-2xl"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
            >
              <iframe
                width="100%"
                height="100%"
                src=""
                title="Our Journey Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              {/* Close Button */}
              <button
                onClick={() => setShowVideo(false)}
                className="absolute top-2 right-2 bg-white/80 text-gray-800 rounded-full px-3 py-1 font-bold text-xl hover:bg-white"
              >
                ✕
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
